import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @property {number} id
 */
export class PaymentGatewayApiSetting extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'profile_id', 'api_key', 'is_active')(PaymentGatewayApiSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/payment-gateway-api-setting.model.js